import React from "react";
import img from "./img/d-shape-1.png";
const DashboardShape1 = () => {
	return <img src={img} alt="" />;
};

export default DashboardShape1;
